// This file is generated automatically and should not be modified.
import { SfIndexedDB } from 'sf-frontend';
import { itdConsumable } from './dbo/ConsumableIndexedDb';
import { itdMeasurementUnit } from './dbo/MeasurementUnitIndexedDb';
import { itdRecipe } from './dbo/RecipeIndexedDb';
import { itdRecipeInputConsumable } from './dbo/RecipeInputConsumableIndexedDb';
import { itdRecipeInstruction } from './dbo/RecipeInstructionIndexedDb';
import { itdPortionCategory } from './dbo/PortionCategoryIndexedDb';
import { itdFamilyMember } from './dbo/FamilyMemberIndexedDb';
import { itdMealPlanAssignment } from './dbo/MealPlanAssignmentIndexedDb';
import { itdStoreProduct } from './dbo/StoreProductIndexedDb';
import { itdConsumableSourcePreference } from './dbo/ConsumableSourcePreferenceIndexedDb';
import { itdScheduleEntry } from './dbo/ScheduleEntryIndexedDb';
import { itdInventoryCount } from './dbo/InventoryCountIndexedDb';
import { itdInventoryCountEntry } from './dbo/InventoryCountEntryIndexedDb';
import { itdUnambiguation } from './dbo/UnambiguationIndexedDb';
import { itdShoppedItem } from './dbo/ShoppedItemIndexedDb';
import { itdShoppingListAddition } from './dbo/ShoppingListAdditionIndexedDb';
import { itdShoppingListSealedDate } from './dbo/ShoppingListSealedDateIndexedDb';
import { itdMeal } from './dbo/MealIndexedDb';

export const initIndexedDb = (): void => {
	SfIndexedDB.initialize('stoneplanner', [
		itdConsumable,
		itdMeasurementUnit,
		itdRecipe,
		itdRecipeInputConsumable,
		itdRecipeInstruction,
		itdPortionCategory,
		itdFamilyMember,
		itdMealPlanAssignment,
		itdStoreProduct,
		itdConsumableSourcePreference,
		itdScheduleEntry,
		itdInventoryCount,
		itdInventoryCountEntry,
		itdUnambiguation,
		itdShoppedItem,
		itdShoppingListAddition,
		itdShoppingListSealedDate,
		itdMeal,
	], 14);
};